import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const DesktopOnlyInline = styled.span`
  display: none;
  pointer-events: none;

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      display: inline-flex;
      pointer-events: auto;
    }
  }
`;

export const MobileOnlyInline = styled.div`
  display: flex;
  pointer-events: auto;

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      display: none;
      pointer-events: none;
    }
  }

  [data-testid='odds-grid'][data-enforce-mobile] & {
    display: flex;
    pointer-events: auto;
  }
`;

export const OddsRow = styled.div`
  display: none;
  pointer-events: none;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  padding: 0 15px;

  > span:first-of-type {
    width: 136px;
  }

  @media (max-width: 767px) {
    display: flex;
    pointer-events: auto;
  }

  [data-testid='odds-grid'][data-enforce-mobile] & {
    display: flex;
    pointer-events: auto;
  }
`;

export const EmptyOddCell = styled.div`
  width: 60px;

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      display: flex;
      justify-content: center;
      align-items: center;
      background: transparent;
      border-radius: 5px;
      width: var(--ogm-grid-cell-width-desktop);
      height: var(--ogm-grid-cell-height-desktop);
    }
  }
`;

export const selectedBet = css`
  font-weight: 800;
  background-color: var(--ogm-grid-selected-cell-bg-color);
  color: var(--ogm-grid-selected-cell-text-color);

  &:hover {
    :after {
      position: absolute;
      min-width: 100%;
      min-height: 100%;
      content: 'X';
      color: var(--ogm-grid-selected-cell-text-color);
      font-weight: 800;
      border-radius: 4px;
      font-family: var(--ogm-font-family-2);
      background: var(--ogm-grid-selected-cell-bg-color);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export const OddsCellWrapper = styled.span`
  width: var(--ogm-grid-cell-width-desktop);
  height: var(--ogm-grid-cell-height-desktop);
  margin: auto;
`;

export const OddsCellBtn = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  width: var(--ogm-grid-cell-width-desktop);

  border-width: 0 0 2px 0;
  border-style: solid;
  border-color: #e0e0e0;

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      border: 1px solid #e5e5e5;
    }
  }

  border-radius: 5px;
  background-color: inherit;
  position: relative;

  transition: background 1s ease;
  will-change: background;
  cursor: pointer;

  font-family: var(--ogm-font-family-2);
  line-height: normal;
`;

export const OddsCellMobile = styled(OddsCellBtn)`
  color: var(--ogm-text-body);
  font-size: 13px;
  font-weight: bold;
  width: 60px;
  height: 33px;

  margin: 0 0 0 auto;

  &.${selectedBet} {
    background-color: var(--ogm-grid-selected-cell-bg-color);
    color: var(--ogm-grid-selected-cell-text-color);
  }
`;

export const OddsCellDesktop = styled(OddsCellBtn)<{ oddsFormat: string }>`
  font-size: ${({ oddsFormat }) => (oddsFormat === 'fractional' ? '10px' : '11px')};
  line-height: ${({ oddsFormat }) => (oddsFormat === 'fractional' ? '1' : 'normal')};
  padding: ${({ oddsFormat }) => (oddsFormat === 'fractional' ? '0 2px' : '0')};
  height: 100%;
  color: black;

  &.${selectedBet} {
    background-color: var(--ogm-grid-selected-cell-bg-color);
  }
`;

export const bestOddsStyles = css`
  color: var(--ogm-grid-best-odds-primary-color);
  height: 33px;
  width: 60px;
  border-radius: 5px;
  display: flex;
  margin-right: 5px;
  line-height: 0;

  & > svg {
    height: 100%;
    width: auto;
    display: block;
  }

  & ${OddsCellDesktop} {
    @media (min-width: 768px) {
      [data-testid='odds-grid']:not([data-enforce-mobile]) & {
        font-weight: 800;
      }
    }
  }

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      height: var(--ogm-grid-cell-height-desktop);
      width: var(--ogm-grid-cell-width-desktop);
      margin-right: unset;
      border: 2px solid var(--ogm-grid-best-odds-primary-color);
      background: var(--ogm-grid-best-odds-secondary-color);
      color: var(--ogm-grid-best-odds-text-color);
      font-weight: 800;
    }
  }
`;

export const oddDrifting = css`
  background-color: var(--oc-odds-drifting-bg);
  border-radius: 5px;

  --oc-cell-rgb: var(--oc-odds-drifting-rgb);
`;

export const oddShortening = css`
  background-color: var(--oc-odds-shortening-bg);
  border-radius: 5px;
`;

export const oddUnsupported = css`
  background: transparent;
  cursor: not-allowed;
`;

export const oddStable = css`
  background: #ececed;
  border-radius: 5px;

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      background: var(--oc-primary-white);
    }
  }
`;

export const noStreamerAnimation = css`
  /* Completely disable all transitions and animations */
  transition: none !important;
  animation: none !important;
  will-change: auto !important;

  /* Preserve original colors but disable transitions */
  &.${oddDrifting} {
    background-color: var(--oc-odds-drifting-bg) !important;
  }

  &.${oddShortening} {
    background-color: var(--oc-odds-shortening-bg) !important;
  }

  @media (min-width: 768px) {
    [data-testid='odds-grid']:not([data-enforce-mobile]) & {
      &.${oddDrifting} {
        background-color: var(--oc-odds-drifting-bg) !important;
      }

      &.${oddShortening} {
        background-color: var(--oc-odds-shortening-bg) !important;
      }
    }
  }
`;

export const betTooltip = css`
  &:not(.${selectedBet}):hover {
    &:after {
      content: 'bet';
      display: block;
      position: absolute;
      min-width: 100%;
      height: 10px;
      top: 0;
      background: var(--ogm-grid-odds-tooltip-bg-color);
      color: var(--oc-primary-white);
      border-radius: 3px 3px 0 0;
      font-weight: 800;
      font-size: 9px;
      line-height: 10px;
      text-align: center;
    }
  }

  &.${bestOddsStyles} {
    &:after {
      border-radius: 3px 3px 0 0;
    }
  }
`;

export const EachWayTermsOddsCell = styled.div`
  margin: 0 0 0 auto;
  display: flex;
  align-items: center;
`;
